<template>
  <div>

    <ImportSteps :titles="['Upload Planilha', 'Mapear colunas', 'Validar planilha', 'Resultado']" :active="active" />
    <transition :name="'import-slide-' + direction" mode="out-in">
      <div :key="active">

        <UploadSheet :fileData="fileData" v-on:upload="fileUpload" v-if="active === 0" v-on:next="next" :sample="false" />

        <MappingColumn :fileData="fileData" :columnData="columnData" :customer="customer" :userType="userType"
          v-on:validate="columnValidate" v-if="active === 1" v-on:next="next" v-on:back="back" />

        <ValidateRowsSender :fileData="fileData" :columnData="columnData" :customer="customer" v-if="active === 2"
          v-on:next="next" v-on:back="back" v-on:create="save" />

        <ResultingSender :records="resultingData" v-if="active === 3" v-on:reset="reset" :customer="customer" />

      </div>
    </transition>
  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import ImportSteps from './ImportSteps.vue';
import MappingColumn from './sender/MappingColumn.vue';
import ResultingSender from './sender/ResultingSender.vue';
import ValidateRowsSender from './sender/ValidateRows.vue';
import UploadSheet from './prepost/UploadSheet.vue';

export default {
  name: "ImportSender",
  props: ["state"],
  components: {
    ImportSteps,
    UploadSheet,
    MappingColumn,
    ValidateRowsSender,
    ResultingSender
  },
  props: ["type"],
  methods: {
    fileUpload(data) {
      const vm = this;
      vm.fileOrigin = data;
      vm.fileData = data;
    },
    columnValidate(data, customer, fileData) {
      const vm = this;
      vm.columnData = data;
      vm.customer = customer;
      vm.fileData = fileData;
    },
    save(data) {
      const vm = this;
      vm.resultingData = data;
      console.log('SAVE DATA ==> ',  save);
    },
    reset() {
      const vm = this;
      vm.columnData = [];
      if (vm.me.type === '2') {
        vm.customer = vm.me.customers ? vm.me.customers.id : '';
      } else {
        vm.customer = "";
      }
      vm.fileData = [];
      vm.resultingData = [];
      vm.direction = 'back';
      vm.active = 0;
    },
    finish() {
      const vm = this;
      vm.active = 2;
    },
    next() {
      const vm = this;
      vm.direction = 'forward';
      vm.active++;
    },
    back() {
      const vm = this;
      vm.direction = 'back';
      vm.active--;
      if (vm.active == 1) {
        vm.fileData = vm.fileOrigin;
      }
    },
  },
  async created() {
    const vm = this;
    vm.me = await UserService.me().catch((error) => {
      this.$message({
        type: "error",
        message: error,
      });
    });
    vm.userType = vm.me.type;
    if (vm.me.type === '2') {
      vm.customer = vm.me.customers ? vm.me.customers.id : '';
    }
  },
  data() {
    return {
      importForm: {
        use: "",
        department: "",
      },
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      columnData: [],
      fileData: [],
      fileOrigin: [],
      resultingData: [],
      userType: '2',
      me: {},
      active: 0,
      direction: 'forward',
      value: [],
      customer: "",
      tableData: [
        {
          label: "CODIGO",
          key: "CODIGO",
          description: "CÓDIGO DO REMETENTE",
        },
        {
          label: "CPF_CNPJ",
          key: "CPF_CNPJ",
          description: "CPF/CNPJ DO REMETENTE",
        },
        {
          label: "DESTINATARIO",
          key: "DESTINATARIO",
          description: "NOME DO REMETENTE",
        },
        {
          label: "EMPRESA",
          key: "EMPRESA",
          description: "EMPRESA RELACIONADA A ENTREGA AO REMETENTE",
        },
        { label: "CEP", key: "CEP", description: "CEP DO REMETENTE" },
        {
          label: "ENDERECO",
          key: "ENDERECO",
          description: "ENDEREÇO DO REMETENTE",
        },
        {
          label: "NUMERO",
          key: "NUMERO",
          description: "NÚMERO DO REMETENTE",
        },
        {
          label: "COMPLEMENTO",
          key: "COMPLEMENTO",
          description: "COMPLEMENTO DO ENDEREÇO DO REMETENTE",
        },
        {
          label: "BAIRRO",
          key: "BAIRRO",
          description: "BAIRRO DO REMETENTE",
        },
        {
          label: "CIDADE",
          key: "CIDADE",
          description: "CIDADE DO REMETENTE",
        },
        { label: "UF", key: "UF", description: "UF DO REMETENTE" },
        {
          label: "TELEFONE",
          key: "TELEFONE",
          description: "TELEFONE DO REMETENTE",
        },
        {
          label: "EMAIL",
          key: "EMAIL",
          description: "EMAIL DO REMETENTE",
        },
        {
          label: "PRODUTO",
          key: "PRODUTO",
          description: "PRODUTO A SER ENVIADO AO REMETENTE",
        },
        {
          label: "EMBALAGEM",
          key: "EMBALAGEM",
          description: "EMBALAGEM UTILIZADO PARA O ENVIO AO REMETENTE",
        },
        {
          label: "INF_ADICIONAL",
          key: "INF_ADICIONAL",
          description: "OBSERVAÇÃO RELACIONADA AO ENVIO PARA O REMETENTE",
        },

        {
          label: "ESPAÇOS",
          key: "ESPAÇOS",
          description:
            "RELACIONADO A CAMPOS A SEREM DESCONSIDERADOS NA IMPORTAÇÃO",
        },
      ],
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => { })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
